import React, { useMemo } from 'react';
import styles from './Content.module.scss';
import ListCellContent from '../../../../../shared/ui/ListCellContent/ListCellContent';
import Item from './components/Item/Item';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import { useShutdownCompanies } from '../../../../../shared/api/queries/shutdownCompanies';

const itemsEmpty = [{ id: 0, name: 'Не указаны' }];

const useGetItemsByCompanies = (items = []) => {
  const { data: companies = [] } = useShutdownCompanies(null, {
    staleTime: Infinity,
  });

  return useMemo(() => {
    const ids = new Set(items);

    return companies.filter((company) => ids.has(company.id));
  }, [companies, items]);
};

const ActiveCompanies = ({ items, rowExpanded = false }) => {
  return (
    <ListCellContent
      className={styles.root}
      items={items || itemsEmpty}
      renderItem={({ item, parentWidth }) => (
        <Item
          item={item}
          parentWidth={parentWidth}
        />
      )}
    />
  );
};

const Content = ({ shutdown, rowExpanded }) => {
  const { canChange } = useShutdownAccesses();

  const items = useGetItemsByCompanies(shutdown.serviceCompanyIds);

  if (!canChange) {
    return (
      <ListCellContent
        className={styles.root}
        items={items || itemsEmpty}
        renderItem={({ item, parentWidth }) => (
          <Item
            item={item}
            parentWidth={parentWidth}
          />
        )}
      />
    );
  }

  return (
    <ActiveCompanies
      items={items}
      rowExpanded={rowExpanded}
    />
  );
};

export default Content;
